export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10100.9ad984e8.jpg";